import { withLoader } from 'util/routeHelper';

export default store => ({
	path: 'sitemap',
	indexRoute: {
		getComponent: withLoader(
			(nextState, cb) =>
				require.ensure(
					[],
					require => {
						const component = require('./component').default;
						cb(null, component);
					},
					'sitemap',
				),
			store,
			'SITEMAP',
		),
	},
});



// WEBPACK FOOTER //
// ./src/routes/SiteMap/index.js